import React from 'react'

function ReviewBred() {
    return (
        <>
            <section className="bredcrumb_section review_banner">
                <div className="container">
                    <div className="section_title text-center" data-aos="fade-up" data-aos-duration={1500} >
                        <span className="sub_text">Seja um Franqueado Parmeca</span>
                        <h2>O restaurante nº1 em comida Italiana</h2>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ReviewBred